<script>
    import Icon from '../icon/Icon.svelte'

    export let callback = () => {}
    export let label = ''
    export let isChecked = false
    export let isDisabled = false
    export let onClickDisabled = () => {}
    export let parentGroup = null
    export let rightAlignedText = null
    export let subText = null
    export let tooltip = null
    export let value = null
    export let isOnDarkBackground = false

    const cid = _.uniqueId()

    export function getState() {
        return isChecked
    }

    export function toggleState() {
        setState(!isChecked)
    }

    export function setState(checked, silent = false) {
        isChecked = checked
        if (!silent && callback) {
            callback(isChecked)
        }
    }

    function onClick() {
        if (isDisabled && onClickDisabled) {
            onClickDisabled()
        }
    }

    function onChange() {
        if (callback) {
            callback(isChecked)
        }
    }
</script>

<!-- svelte-ignore a11y-click-events-have-key-events -->
<!-- svelte-ignore a11y-no-noninteractive-element-interactions -->
<!-- Label needs to be clickable to explain why a checkbox is disabled -->
<label
    id={cid}
    class="checkbox"
    title={tooltip}
    on:click|stopImmediatePropagation={onClick}>
    <input
        type="checkbox"
        name={parentGroup}
        {value}
        disabled={isDisabled}
        bind:checked={isChecked}
        on:change={onChange}
    />
    <span class="checkbox__box" class:is-on-dark-background={isOnDarkBackground}>
        <Icon name="checkmark"></Icon>
    </span>
    <span class="label-container">
        <span class="label">
            <slot name="label">
                {label}
            </slot>
        </span>
        {#if subText}
            <span class="sub-text">{subText}</span>
        {/if}
    </span>
    {#if rightAlignedText}
        <span class="right-aligned-text">{rightAlignedText}</span>
    {/if}
</label>

<style lang="scss">/*
* Scut, a collection of Sass utilities
* to ease and improve our implementations of common style-code patterns.
* v1.0.1
* Docs at http://davidtheclark.github.io/scut
*/
/* TODO implement tooltip arrow */
.checkbox {
  position: relative;
  display: flex;
  align-items: center;
  cursor: pointer;
}
.checkbox:has(input:disabled) {
  cursor: not-allowed;
}
.checkbox__box {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 24px;
  width: 24px;
  min-width: 24px;
  border-radius: 8px;
  border: 1px solid #9a9bb5;
  background-color: #fff;
}
.checkbox__box > :global(svg) {
  display: none;
  width: 100%;
  fill: #fff;
}
.checkbox input {
  position: absolute;
  opacity: 0;
  z-index: -1;
}
.checkbox input:checked ~ .checkbox__box {
  background-color: hsl(205, 60%, 44%);
  border-color: hsl(205, 60%, 44%);
}
.checkbox input:checked ~ .checkbox__box.is-on-dark-background {
  background-color: #fff;
  border-color: #9a9bb5;
}
.checkbox input:checked ~ .checkbox__box.is-on-dark-background > :global(svg) {
  fill: #122d40;
}
.checkbox input:checked ~ .checkbox__box > :global(svg) {
  display: block;
}
.checkbox input:focus ~ .checkbox__box {
  box-shadow: 0 0 10px 0 rgba(44.88, 123.42, 179.52, 0.5);
}
.checkbox input:disabled ~ .checkbox__box {
  border-color: hsl(27, 15%, 93%);
}
.checkbox input:disabled:checked ~ .checkbox__box {
  background-color: hsl(27, 15%, 93%);
}
.checkbox .label-container {
  flex-grow: 1;
}
.checkbox .sub-text {
  margin-top: 2px;
  color: #9a9bb5;
}
.checkbox .label:not(:empty),
.checkbox .sub-text:not(:empty) {
  display: block;
  user-select: none;
  margin-left: 16px;
}
.checkbox .right-aligned-text {
  color: #9a9bb5;
  flex-grow: 1;
  text-align: right;
  margin-left: 10px;
  user-select: none;
}</style>
